module.exports = __webpack_public_path__ + "static/img/banner-logo.e8a8655.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Probuild/banner-logo.svg
// module id = o0P5
// module chunks = 0